export const selectPauseDeflectionModal = state => state.pauseDeflectionModal
